import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import media from './fpp_media_queries';
import { color, fontSize, lineHeight, space } from '@core-ds/primitives';

const MainHeading = styled.h2({
   fontSize: fontSize['9xl'],
   fontWeight: 900,
   textTransform: 'uppercase',
   lineHeight: lineHeight.none,
   textAlign: 'center',
   borderBottom: 'none',
   padding: 0,
   margin: '0 auto',
   whiteSpace: 'pre-line',
   color: color.gray[900],

   [media.mobileLandscapeAll]: {
      fontSize: 60,
   },

   [media.mobile]: {
      fontSize: 34,
      lineHeight: 1.2,
   },
});

const SubHeading = styled.h2({
   fontSize: fontSize['3xl'],
   fontWeight: 400,
   borderBottom: 'none',
   padding: 0,
   margin: 0,
   textAlign: 'center',
   color: color.gray[900],

   [media.mobile]: {
      fontSize: fontSize['2xl'],
   },
});

const Body = styled.p(props => ({
   fontSize: fontSize.lg,
   fontWeight: 400,
   lineHeight: 2.2,
   textAlign: 'center',
   display: 'block',
   margin: '0 auto',
   paddingTop: space[4],
   color: color.gray[500],
   maxWidth: props.maxWidth,

   [media.mobile]: {
      fontSize: fontSize.md,
   },
}));

const TextComponent = ({ heading, subheading, body, maxWidth }) => (
   <div>
      {heading && <MainHeading>{heading}</MainHeading>}
      {subheading && <SubHeading>{subheading}</SubHeading>}
      {body && <Body maxWidth={maxWidth}>{body}</Body>}
   </div>
);

TextComponent.propTypes = {
   heading: PropTypes.string,
   subheading: PropTypes.string,
   body: PropTypes.string,
   maxWidth: PropTypes.number,
};

TextComponent.defaultProps = {
   heading: null,
   subheading: null,
   body: null,
   maxWidth: 600,
};

export default TextComponent;
